<div
  id="BaseMapSwitchComponent"
  class="card esri-widget"
  [hidden]="hiddenContainer"
  #baseMapSwitchComponentRef
>
  <!--- the card header -->
  <div class="card-header" #dragHandle>
    <div class="row">
      <div class="col-md-9" translate>
        WIDGET.BASEMAP_SWITCH.PANEL_HEADING
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>
  <!-- the card body -->
  <div class="card-body">
    <arcgis-basemap-gallery #baseMapRef></arcgis-basemap-gallery>
  </div>
</div>
